export default {
    namespaced: true,
    state() {
        return {
            failureStatus: 'unresolved',
        };
    },
    getters: {
        failureStatus: state => state.failureStatus,
    },
    mutations: {
        setFailureStatus(state, failureStatus) {
            state.failureStatus = failureStatus;
        },
    },
    actions: {
        async changeFailureStatus({ commit }, value) {
            commit('setFailureStatus', value);
        },
    },
};
